module.exports = __webpack_public_path__ + "20865e815f.png";